import React from 'react';

const Blog = () => {
    return (
        <div className='container'>
            <h3 className='text-center text-decoration-underline p-3 m-4'>Question part:</h3>
            <div className=' row m-auto gap-3 justify-content-center mt-5'>
                <div className="col-md-3 border rounded p-4 bg-secondary text-light">
                    <h5 className='mt-3'>1.What is Context API?</h5>
                    <p><span className='fw-bold'>Answer: </span>Context API is a way to pass data directly through the component tree. Usually we need to pass props from parent to child manually at every level. but the context API makes the code cleaner by reducing the amount of props and gives more control to the root components.</p>
                </div>
                <div className='col-md-3 border rounded p-4 bg-secondary text-light'>
                    <h5 className='mt-3'>1.What is Symantic Tag?</h5>
                    <p><span className='fw-bold'>Answer: </span>Those tags is called Symantic Tag which are understood by both the browser and the developer. Such as 'header', 'footer', 'form', 'table' etc are clearly express their content </p>
                </div>
                <div className='col-md-3 border rounded p-4 bg-secondary text-light'>
                    <h5 className='mt-3'>1.Differance between Inline and Inline block elements?</h5>
                    <p><span className='fw-bold'>Answer: </span>Inline element take up the whole space of an entire line while Inline Block elements are like blocks as they take just their own space which depends on their weidth.</p>

                </div>
            </div>



        </div>
    );
};

export default Blog;